<template>
   <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col style="padding:0" align="center">
            <div class="menu-top" style="text-align:center">
              <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
            </div>
            <div>
              <img class="menu-overlay"
                :src="require('@/assets/img/menu.png')"
                v-b-toggle.menu-sidebar
              >
            </div>
            <hr>
          </b-col>
        </b-row>
        <p class="w-pagetitle" style="margin-left:20px;margin-right:5px; text-align:right;">{{cellar.name}} > {{ translate("search") }}</p>
        <!-- <b-row class="justify-content-center">
          <p class="t-title">{{ translate("search bottles in") }} {{cellar.name}}</p>
        </b-row> -->

        <b-form class="w-search" style="width:90%; margin:0 auto;" @submit.prevent>
          <br><br>
          <h1 class="main-title"><b><span style="color: rgb(195,147,130)">WYNE</span></b><span style="color: black">CELLAR</span></h1>
          <p class="t-title" style="text-align: center; position:relative; top:-15px;">{{ translate("search bottles in") }} {{cellar.name}}</p>
          <br>
          <!-- <b-form-group>
            <b-form-input
              id="input-search"
              class = "w-input"
              style = "background-color:white !important;  padding-left: 40px"
              v-model="search_text"
              aria-describedby="input-live-help input-live-feedback"
            ></b-form-input>              
          </b-form-group> -->

              <b-form-group>
                <b-form-input
                  v-if="isLoadingEntries"
                  id="input-search-loading"
                  class="w-input"
                  style="background-color:white !important; padding-left: 40px"
                  value=""
                  disabled
                  :placeholder="translate('loading cellar entries')"
                />

                <b-form-input
                  v-else
                  id="input-search"
                  class="w-input"
                  style="background-color:white !important; padding-left: 40px"
                  v-model="search_text"
                  aria-describedby="input-live-help input-live-feedback"
                />
              </b-form-group>  

          <div style="width:20px; position: relative; float:left; top: -39px; left: 10px; margin: 0; padding:0">
            <font-awesome-icon 
              style="font-size:17px;color: rgb(109,122,82);" 
              icon="search" />
          </div>

          <!-- Zero/ Non Zero-->
          <div class="d-flex justify-content-end align-items-center" style="margin-right:40px">
            <b-form-checkbox
              id="notzeroToggle"
              v-model="notzerobottles"
              class="mb-0"
              style="margin-right: 10px;"
              @change="onNotZeroChanged"
            >
              # {{ translate("bottles") }} > 0
            </b-form-checkbox>

            <b-form-checkbox
              id="zeroToggle"
              v-model="zerobottles"
              class="mb-0"
              @change="onZeroChanged"
            >
              # {{ translate("bottles") }} = 0
            </b-form-checkbox>
          </div>

          <!-- Counts -->
          <div class="w-results-toolbar">
            <div class="w-results-count">
              {{ translate("showing") }} {{ filteredEntries.length }} {{ translate("bottles") }}  
            </div>
          </div>
        </b-form>        

        <div v-if="!isLoadingEntries">
          <!-- Results -->
          <b-row class="justify-content-center" style="margin:0">              
            <b-col
              v-for="(entry, index) in visibleEntries"
              v-bind:item="entry"
              v-bind:index="index"
              v-bind:key="entry._id" 
              class="w-tile m-2 d-inline-flex justify-content-center w-cursor-click"
              xs="12" sm="6" md="4" lg="2" xl="2"
              style ="display:block; min-width:300px; margin:20px !important"
            >
              <b-row 
                style="width:100%"
                v-on:click="onSelect(entry._id,entry.niche_id,entry.niche_id)"
              >
                <b-col cols="3" class="justify-content-center" style="height:100%;width:auto;padding:0">
                  <b-img center v-if="entry.image_files[0]"
                    style="height:100%;width:auto;position:absolute;right:0px"
                    v-bind:src="entry.image_files[0].dataURL" 
                  ></b-img>
                  <b-img center v-else
                    style="height:100%;width:auto;position:absolute;right:0px"
                    :src="require('@/assets/img/bottle.png')"
                  ></b-img>
                </b-col>
                <b-col cols="9" class="d-table-cell">
                  <div>
                    <p class="t-title">{{entry.vintage}}</p>
                    <p class="t-title2">{{entry.name}}</p>
                    <p class="t-subtitle" v-if="entry.type">{{entry.type}}</p>
                    <p class="t-subtitle" style="color:white" v-else>bogus text here</p>
                    <hr style="margin:5px 0 5px 0">
                    <p class="t-text" v-if="entry.appellation">{{entry.appellation}}</p>
                    <p class="t-smalltext" v-if="entry.classification">{{entry.classification}}</p>
                    <p class="t-smalltext" v-if="entry.color">{{entry.color}}</p>
                    <p class="c-bottles">{{entry.number}}</p>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br>
          <Paginator
            v-if="visibleEntries.length >0"
            v-model="current_page"
            :total-rows= "filteredEntries.length"
            :per-page.sync="per_page"
          />
        </div>

        <b-sidebar 
          id="menu-sidebar" 
          backdrop
          backdrop-variant="dark" 
          no-header
          shadow
        >
          <template #default="{ hide }">
            <div style="display: flex; align-items: center;">
              <div style="display: flex;align-items: center; width:25 px">
                <b-dropdown 
                  left 
                  split 
                  text="language" 
                  class="language-dropdown" 
                  toggle-class="toggle-language" 
                  split-class="split-language" 
                  style="display: flex;font-size: 12px;margin:15px 0 0 10px"
                >
                  <template #button-content>
                    <img
                      :src="currentLanguageFlag"
                      style="width:28px; height:19px; border-radius:2px;"
                    >
                  </template>

                  <b-dropdown-item @click="selectLanguage('en')">
                    <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                    English
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('fr')">
                    <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                    Français (French)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('de')">
                    <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                    Deutsch (German)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('es')">
                    <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                    Español (Spanish)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('it')">
                    <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                    Italiano (Italian)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('nl')">
                      <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                      Nederlands (Dutch)
                    </b-dropdown-item>
                    <b-dropdown-item @click="selectLanguage('pt')">
                      <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                      Português (Portuguese)
                    </b-dropdown-item>
                </b-dropdown>
              </div>
              <div style="display: flex; align-items: center;">
                <p style="margin:20px 0 0 40px;"><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
              </div>
              <div style="display: flex; align-items: center; width:25 px">
                <img class="menu-overlay"
                  :src="require('@/assets/img/close.png')" 
                  style="width: 25px; height: 25px; cursor: pointer;" 
                  @click="hide"
                >
              </div>
            </div>
            <hr>
            <Menu/> 
          </template>
        </b-sidebar>
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>
  </div>
</template>

<script>
  import NoAccess from '@/components/NoAccess.vue';
  import Menu from '@/components/MenuMobile.vue';
  import Paginator from "@/components/Paginator.vue";

  import {wordlist,translate_word} from '../assets/js/translate.js';

  import Users from '../Users.js';
  import Entries from '../Entries.js'

  export default {
    name: "Search",
    components: {
      NoAccess,
      Menu,
      Paginator,
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },

      currentUser() {
        return this.$store.state.user
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },

      currentCellarID() {
        return this.$store.state.cellar_id
      },
      currentCellar() {
        return this.$store.state.cellar
      },
      currentCellarLoaded() {
        return this.$store.state.cellar_loaded
      },

      filteredEntries() {
        const normalizedSearch = this.normalizeSearchText(this.search_text)

        if (!normalizedSearch) {
          return []
        }

        const keywords = normalizedSearch
          .split(" ")
          .filter(Boolean)

        return this.entries
          .filter(entry => {
            const number = Number(entry.number) || 0

            return (
              (number > 0 && this.notzerobottles) ||
              (number === 0 && this.zerobottles)
            )
          })
          .filter(entry => {
            const text = this.normalizeSearchText(
              [
                entry.name,
                entry.type,
                entry.country,
                entry.region,
                entry.appellation,
                entry.classification,
                entry.color,
                entry.grapes,
                entry.vintage
              ]
                .filter(value => value !== null && value !== undefined)
                .join(" ")
            )

            return keywords.every(keyword => text.includes(keyword))
          })
      },

      visibleEntries() {
        const start = (this.current_page - 1) * this.per_page
        return this.filteredEntries.slice(
          start,
          start + this.per_page
        )
      }      
    },
    watch: {
      search_text() {
        this.current_page = 1
        this.saveSearchState()
      },
      zerobottles() {
        this.saveSearchState()
      },
      notzerobottles() {
        this.saveSearchState()
      }
    },
    data() {
      return {
        debug: false,
        isLoading: true,
        isLoadingEntries: true,

        languages:[
          {text:'English',value:'en'},
          {text:'Français',value:'fr'},
          {text:'Deutsch',value:'de'},
          {text:'Español',value:'es'},
          {text:'Italiano',value:'it'},
          {text:'Nederland',value:'nl'},
          {text:'Português',value:'pt'},
        ],

        entries: [],

        search_text:"",
        current_page: 1,
        per_page:6,

        zerobottles: false,
        notzerobottles: true,

        source_page: "",
      }
    },

    async mounted() {
      let local_debug = false

      if (local_debug || this.debug) console.log("")
      if (local_debug || this.debug) console.log("Search.mounted: START")

      // Retrieve cellar from store
      if (this.currentCellarLoaded) {
        this.cellar = this.currentCellar
        this.cellar_id = this.currentCellarID

        if (local_debug || this.debug) {
          console.log(
            "Search.mounted: cellar ",
            this.cellar,
            " with id ",
            this.cellar_id,
            " successfully retrieved from store."
          )
        }
      } else {
        console.log("Search.mounted: FATAL ERROR cellar NOT loaded.")
      }

      // Where did we come from?
      if (this.$route.query.source_page) {
        this.source_page = this.$route.query.source_page
      }

      // Restore previous search state when returning from EntryShow
      if (this.source_page === "Search") {
        const searchState = this.$store.getters.currentSearchState

        this.search_text = searchState.search_text
        this.notzerobottles = searchState.notzerobottles
        this.zerobottles = searchState.zerobottles
        this.entries = searchState.entries

        this.isLoadingEntries = false
      } else {
        this.search_text = ""
        this.notzerobottles = true
        this.zerobottles = false
        this.entries = []

        this.isLoadingEntries = true
      }

      // Main page itself can now be displayed.
      // The search field remains disabled while entries are loading.
      this.isLoading = false

      // Load cellar entries if they are not already available
      if (this.entries.length === 0) {

        if (
          this.cellar_id !== 0 &&
          this.cellar.entry_ids?.length > 0
        ) {
          const validEntryIds = this.cellar.entry_ids.filter(
            id => typeof id === "string" && id.length === 24
          )

          if (validEntryIds.length > 0) {

            // IMPORTANT:
            // keep search disabled until Entries.getmany() has REALLY finished
            this.isLoadingEntries = true

            try {
              const entries = await Entries.getmany(validEntryIds)

              if (!Array.isArray(entries)) {
                throw new Error(
                  "Search.mounted: Entries.getmany() did not return an array"
                )
              }

              this.entries = entries
                .filter(entry => entry && typeof entry === "object")
                .filter(entry => entry.niche_id !== "archived")
                .sort((a, b) => {
                  const nameA = a.name || ""
                  const nameB = b.name || ""

                  return nameB.localeCompare(nameA)
                })

              if (local_debug || this.debug) {
                console.log(
                  "Search.mounted:",
                  this.entries.length,
                  "entries successfully fetched from DB"
                )
              }

            } catch (error) {

              if (local_debug || this.debug) {
                console.error(
                  "Search.mounted: failed to load entries",
                  error
                )
              }

              this.entries = []

              this.$bvToast?.toast(
                "Unable to load entries.",
                {
                  title: "Database Error",
                  variant: "danger",
                  solid: true
                }
              )

            } finally {

              // Search becomes available ONLY after getmany() has completed
              this.isLoadingEntries = false
            }

          } else {
            this.isLoadingEntries = false
          }

        } else {
          this.isLoadingEntries = false
        }

      } else {

        this.isLoadingEntries = false

        if (local_debug || this.debug) {
          console.log(
            "Search.mounted: using cached entries."
          )
        }
      }

      if (local_debug || this.debug) {
        console.log("Search.mounted: STOP")
      }
    },
        
    methods:{
      onSelect(entry_id,cellar_id,niche_id) {
        let local_debug = false
        if (local_debug) console.log("Search.onSelect: entry_id = ", entry_id);
        this.$store.commit('setPage','EntryShow')
        this.$router.push({path:'/EntryShow', query: {entry_id:entry_id,cellar_id:cellar_id,niche_id:niche_id}});
      },

      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: START");
        this.$store.commit('setLanguage',language)

        let user = this.currentUser
        let user_id = this.currentUserID
        user.language = language
        await Users.update(user_id, user)
        .then(response => {
          if (local_debug || this.debug) console.log ("TastingsOverview.selectLanguage: user ",user.email," updated with response ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('TastingsOverview.selectLanguage: catch await Users.update ERROR : ', error);
        })

        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: STOP");
      },

      normalizeSearchText(value) {
        let text = String(value || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/ß/g, "ss")
          .replace(/æ/g, "ae")
          .replace(/œ/g, "oe")
          .replace(/\u00a0/g, " ")           // non-breaking spaces
          .replace(/[’‘`´]/g, "'")           // normalize apostrophes
          .replace(/[-–—_/.,;:()[\]{}]/g, " ") // punctuation
          .replace(/\s+/g, " ")
          .trim()

        const synonyms = {
          // colors
          blanc: "white",
          wit: "white",
          weiss: "white",
          bianco: "white",
          branco: "white",

          rouge: "red",
          rood: "red",
          rot: "red",
          rosso: "red",
          rojo: "red",
          tinto: "red",

          rose: "rose",
          rosado: "rose",
          rosato: "rose",

          // countries
          france: "france",
          frankrijk: "france",
          frankreich: "france",
          francia: "france",
          franca: "france",

          spain: "espana",
          espagne: "espana",
          espana: "espana",
          spanje: "espana",
          spanien: "espana",
          spagna: "espana",

          italy: "italia",
          italie: "italia",
          italien: "italia",
          italia: "italia",

          germany: "deutschland",
          allemagne: "deutschland",
          duitsland: "deutschland",
          alemania: "deutschland",
          germania: "deutschland",
          deutschland: "deutschland",

          austria: "osterreich",
          osterreich: "osterreich",
          autriche: "osterreich",
          oostenrijk: "osterreich",

          portugal: "portugal",

          greece: "ellada",
          grece: "ellada",
          griekenland: "ellada",
          griechenland: "ellada",
          grecia: "ellada",
          ellada: "ellada"
        }

        return text
          .split(" ")
          .filter(Boolean)
          .map(word => synonyms[word] || word)
          .join(" ")
      },   

      onNotZeroChanged(value) {
        if (!value && !this.zerobottles) {
          this.notzerobottles = true
          return
        }

        this.notzerobottles = value
      },

      onZeroChanged(value) {
        if (!value && !this.notzerobottles) {
          this.notzerobottles = true
          this.zerobottles = false
          return
        }

        this.zerobottles = value
      },

      saveSearchState() {
        this.$store.commit("setSearchState", {
          search_text: this.search_text,
          notzerobottles: this.notzerobottles,
          zerobottles: this.zerobottles,
          entries: this.entries
        })
      },
      
      translate(string) {
        return translate_word(string, this.currentLanguage);
      },

      doNothing() {
      },
    }
  }    
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
.search-checkbox-mobile {
  font-size: 0.8rem;
}

.search-checkbox-mobile >>> .custom-control-label::before {
  width: 0.8rem;
  height: 0.8rem;
  top: 0.2rem;
}

.search-checkbox-mobile >>> .custom-control-label::after {
  width: 0.8rem;
  height: 0.8rem;
  top: 0.2rem;
}

.search-checkbox-mobile >>> .custom-control-label {
  padding-left: 0 rem;
}
</style>